import moment from 'moment'
/*单选题正则表达式*/
export const dxPattern = /@[0-9]+(=|!=)+[0-9]+ /i
export const dxPattern2 = /@[0-9]+(=|!=)[[](([0-9]+[-][0-9]+)|([0-9]+))(,(([0-9])+|[0-9]+[-][0-9]+))*] /i

export const dmPattern3 = /@[0-9]+(=|!=)[[](([0-9]+[-][0-9]+)|([0-9]+))(,(([0-9])+|[0-9]+[-][0-9]+))*] /i
export const dmPattern = /@[0-9]+(=|!=)[[][(^)|(?)|(*)](([0-9]+[-][0-9]+)|([0-9]+))(,(([0-9])+|[0-9]+[-][0-9]+))*] /i
export const dmPattern2 = /@[0-9]+[[][$](([0-9]+[-][0-9]+)|([0-9]+))(,(([0-9])+|[0-9]+[-][0-9]+))*](=|!=|>=|<=|<|>)[0-9]+ /i
export const dmLenPattern = /@[1-9]+(!=|=|<=|>=|>|<)[[]##[0-9]+] /i
//矩阵单选
export const jzxPattern = /@[0-9]+[[0-9]+(=|!=)[0-9]+] /i
export const jzxPattern2 = /@[0-9]+[[0-9]+(=|!=)[0-9]+(,[0-9]+)*] /i
//矩阵多选
export const jzmPattern = /@[1-9]+[[][(^)|(?)|(*)][0-9]+(=|!=)(([0-9]+[-][0-9]+)|([0-9]+))(,(([0-9])+|[0-9]+[-][0-9]+))*] /i
export const jzmPattern2 = /@[1-9]+[[][$][0-9]+=(([0-9]+[-][0-9]+)|([0-9]+))(,(([0-9])+|[0-9]+[-][0-9]+))*](>=|<=|=|<|>|!=)[0-9]+ /i
export const jzmLenPattern = /@[0-9]+[[]##[0-9]+(>=|<=|=|<|>|!=)[0-9]+] /i
//文本题逻辑
export const wbPattern = /@[0-9]+(=|!=)([^]*%|%[^]*|%[^]*%) /i
export const wbPattern2 = /@[0-9]+(=|!=|>=|<=|<|>)+[0-9]+ /i
//多行文本题
export const wmPattern = /@[0-9]+[[][0-9]+(=|!=)([^]*%|%[^]*|%[^]*%)] /i
export const wmPattern2 = /@[0-9]+[[][0-9]+(=|!=|>=|<=|<|>)[0-9]+] /i
//级联题逻辑
export const jlPattern = /@[1-9]+(=|!=)[[][0-9]+(.[0-9]+)*(,[0-9]+(.[0-9]+)*)*] /
//特殊的逻辑
export const EXCLUDE = /EXCLUDE[[](([0-9]+[-][0-9]+)|([0-9]+))(,(([0-9])+|[0-9]+[-][0-9]+))*]/i
//隐藏莫题目选择的答案
export const EXCLUDETOW = /EXCLUDE[[]@[0-9]+,(SELECTED|NOSELECTED)]/i
export const M_EXCLUDE = /M_EXCLUDE[[](([0-9]+[-][0-9]+)|([0-9]+))(,(([0-9])+|[0-9]+[-][0-9]+))*]/i
export const M_EXCLUDETOW = /M_EXCLUDE[[]@[0-9]+,(SELECTED|NOSELECTED)]/i
export const I_EXCLUDE = /I_EXCLUDE[[]([0-9]+.[0-9]+)(,[0-9]+.[0-9]+)*]/i
export const C_EXCLUDE = /C_EXCLUDE[[][0-9]+(.[0-9]+)*(,[0-9]+(.[0-9]+)*)*]/i
export const formatDate = data => {
  return moment(data).format('YYYY-MM-DD H:mm:s')
}
export const formatDateStr = (date, format) => {
  return moment(date).format(format)
}
export const htmlImg = (content) => {
  if (content) {
    content = content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, '[图片]')
    return content.replace(/(<([^>]+)>)/ig, '')
  }
  return "";

}
export const createRuleList = (list) => {
  var arr
  arr = list.sort()
  var rule = []
  var thenRuleList = []

  //分离选项规则
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] === arr[i + 1] - 1) {
      thenRuleList.push(arr[i])
    } else {
      thenRuleList.push(arr[i])
      rule.push(thenRuleList)
      thenRuleList = []
    }
  }
  //规则转化成字符串并且加上-，如果没有-就直接转换字符串
  for (var e = 0; e < rule.length; e++) {
    if (rule[e].length < 2) {
      rule[e] = JSON.stringify(rule[e][0])
    } else {
      rule[e] = rule[e][0] + '-' + rule[e][rule[e].length - 1]
    }
  }
  return rule
}

function excludeFun(srt1, str2, type = 'exclude') {
  let result = {
    type: 'n',
    contexts: []
  }
  if (type === 'exclude' && srt1 === ' ' && EXCLUDE.test(('exclude' + str2).toUpperCase())) {
    let jumpInfo = str2
    let context = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    //然后我还想以,分成数组来这样我就知道数组0代表的是获取的题目,数组1获取的是属性
    result.contexts = context.split(',').map(Number)
    result.type = '1'
    return result
  } else if (type === 'exclude' && srt1 === ' ' && EXCLUDETOW.test(('exclude' + str2).toUpperCase())) {
    let jumpInfo = str2
    let context = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    //然后我还想以,分成数组来存储它吧
    let contexts = context.split(',')
    //这时候我就想着怎么存放需要隐藏的序列号 于是我想到了数组
    result.type = '2'
    result.contexts = contexts
  } else if (type === 'c_exclude' && srt1 === ' ' && C_EXCLUDE.test('c_exclude' + str2)) {
    let jumpInfo = str2
    let context = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    let contexts = context.split(',')
    result.contexts = contexts.reduce((a, b, index) => {
      a.push(b.split('.'))
      return a
    }, [])
    result.type = '3'
  } else if (type === 'i_exclude' && srt1 === ' ' && I_EXCLUDE.test('i_exclude' + str2)) {
    let jumpInfo = str2
    let context = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    let contexts = context.split(',')
    result.contexts = contexts.reduce((a, b, index) => {
      a.push(b.split('.').map(Number))
      return a
    }, [])
    result.type = '4'
  } else if (type === 'm_exclude' && srt1 === ' ' && M_EXCLUDE.test('m_exclude' + str2)) {
    let jumpInfo = str2
    let context = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    //然后我还想以,分成数组来这样我就知道数组0代表的是获取的题目,数组1获取的是属性
    result.contexts = context.split(',').map(Number)
    result.type = '5'
    return result
  } else if (type === 'm_exclude' && srt1 === ' ' && M_EXCLUDETOW.test('m_exclude' + str2)) {
    let jumpInfo = str2
    let context = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    //然后我还想以,分成数组来存储它吧
    let contexts = context.split(',')
    contexts[1] = 'm_' + contexts[1]
    //这时候我就想着怎么存放需要隐藏的序列号 于是我想到了数组
    result.type = '6'
    result.contexts = contexts
  }
  return result
}

function logicDx(jump, showAttrList, index, infoIndex, jumpList, question) {
  let range = undefined
  let jumpInfo = jump
  if (dxPattern.test(jumpInfo)) {
    showAttrList[index].exprList[infoIndex].type = question.type
    if (jumpInfo.indexOf('!=') > -1) {
      showAttrList[index].exprList[infoIndex].condition = '!='
      range = jumpInfo.split('!=')
    } else if (jumpInfo.indexOf('=') > -1) {
      showAttrList[index].exprList[infoIndex].condition = '='
      range = jumpInfo.split('=')
    }
    jumpList[index].list[infoIndex] = question.optionList
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    showAttrList[index].exprList[infoIndex].option = parseInt(range[1])
  } else if (dxPattern2.test(jumpInfo)) {
    if (jumpInfo.indexOf('!=') > -1) {
      showAttrList[index].exprList[infoIndex].condition = '*!='
      range = jumpInfo.split('!=')
    } else if (jumpInfo.indexOf('=') > -1) {
      showAttrList[index].exprList[infoIndex].condition = '*='
      range = jumpInfo.split('=')
    }
    showAttrList[index].exprList[infoIndex].type = question.type
    jumpList[index].list[infoIndex] = question.optionList
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    let arr = range[1].substring(range[1].indexOf('[') + 1, range[1].indexOf(']')).split(',')
    //获取制定的数组
    let answerOption = []
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].indexOf('-') !== -1) {
        let itemComma = arr[i].split('-')
        arr[i] = itemComma
      }
      // 分类必选项
      if (typeof (arr[i]) === 'string') { //必须
        answerOption.push(parseInt(arr[i]))
      } else { //可选
        //循环出可选答案 列如1-4，那么生成1,2,3,4
        for (let d = Number(arr[i][0]); d < Number(arr[i][1]) + 1; d++) {
          answerOption.push(d)
        }
      }
    }
    showAttrList[index].exprList[infoIndex].optionList = answerOption
  }
}

/**
 * 条件为矩阵单选
 * @param jump
 * @param showAttrList
 * @param index
 * @param infoIndex
 * @param jumpList
 * @param question
 */
function logicDm(jump, showAttrList, index, infoIndex, jumpList, question) {
  // console.log('logicDm', index)
  let jumpInfo = jump
  /*index 为什么会等于un*/
  showAttrList[index].exprList[infoIndex].type = question.type
  if (dmPattern.test(jumpInfo)) {
    let range = []
    let type = 'eq'
    if (jumpInfo.indexOf('!=') > -1) {
      range = jumpInfo.split('!=')
      type = 'ne'
    } else if (jumpInfo.indexOf('=') > -1) {
      range = jumpInfo.split('=')
      type = 'eq'
    }
    let arr = range[1].substring(range[1].indexOf('[') + 2, range[1].indexOf(']')).split(',')
    if (range[1][1] === '?') {
    } else if (range[1][1] === '*') {
      let mustArr = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].indexOf('-') !== -1) {
          arr[i] = arr[i].split('-')
        }
        // 分类必选项
        if (typeof (arr[i]) === 'string') { //必须
          mustArr.push(parseInt(arr[i]))//必选的
        } else { //可选
          //循环出可选答案 列如1-4，那么生成1,2,3,4
          for (let d = Number(arr[i][0]); d < Number(arr[i][1]) + 1; d++) {
            mustArr.push(d)
          }
        }
      }
      showAttrList[index].exprList[infoIndex].contain = type === 'ne' ? '!*' : '*'
      showAttrList[index].exprList[infoIndex].option = parseInt(mustArr[0])
      jumpList[index].list[infoIndex] = question.optionList
    } else if (range[1][1] === '^') {
      let mustArr = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].indexOf('-') !== -1) {
          arr[i] = arr[i].split('-')
        }
        // 分类必选项
        if (typeof (arr[i]) === 'string') {
          mustArr.push(parseInt(arr[i]))//必选的
        } else { //可选
          //循环出可选答案 列如1-4，那么生成1,2,3,4
          for (let d = Number(arr[i][0]); d < Number(arr[i][1]) + 1; d++) {
            mustArr.push(d)
          }
        }
      }
      showAttrList[index].exprList[infoIndex].contain = type === 'ne' ? '!^' : '^'
      showAttrList[index].exprList[infoIndex].optionList = mustArr
    }
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    jumpList[index].list[infoIndex] = question.optionList
  } else if (dmPattern2.test(jumpInfo)) {
    let range = []
    if (jumpInfo.split('!=').length > 1) {
      range = jumpInfo.split('!=')
      showAttrList[index].exprList[infoIndex].condition = '!='
    } else if (jumpInfo.split('>=').length > 1) {
      range = jumpInfo.split('>=')
      showAttrList[index].exprList[infoIndex].condition = '>='
    } else if (jumpInfo.split('<=').length > 1) {
      range = jumpInfo.split('<=')
      showAttrList[index].exprList[infoIndex].condition = '<='
    } else if (jumpInfo.split('=').length > 1) {
      range = jumpInfo.split('=')
      showAttrList[index].exprList[infoIndex].condition = '='
    } else if (jumpInfo.split('<').length > 1) {
      range = jumpInfo.split('<')
      showAttrList[index].exprList[infoIndex].condition = '<'
    } else if (jumpInfo.split('>').length > 1) {
      range = jumpInfo.split('>')
      showAttrList[index].exprList[infoIndex].condition = '>'
    }
    //设置类型
    let arr = range[0].substring(range[0].indexOf('[') + 2, range[0].indexOf(']')).split(',')
    //获取制定的数组
    let answerOption = []
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].indexOf('-') !== -1) {
        let itemComma = arr[i].split('-')
        arr[i] = itemComma
      }
      // 分类必选项
      if (typeof (arr[i]) === 'string') { //必须
        answerOption.push(parseInt(arr[i]))
      } else { //可选
        //循环出可选答案 列如1-4，那么生成1,2,3,4
        for (let d = Number(arr[i][0]); d < Number(arr[i][1]) + 1; d++) {
          answerOption.push(d)
        }
      }
    }
    showAttrList[index].exprList[infoIndex].contain = '$'
    showAttrList[index].exprList[infoIndex].optionList = answerOption
    showAttrList[index].exprList[infoIndex].textOption = parseInt(range[1])
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    jumpList[index].list[infoIndex] = question.optionList
  } else if (dmPattern3.test(jumpInfo)) {
    let range = undefined
    if (jumpInfo.indexOf('!=') > -1) {
      showAttrList[index].exprList[infoIndex].contain = '!^'
      range = jumpInfo.split('!=')
    } else if (jumpInfo.indexOf('=') > -1) {
      showAttrList[index].exprList[infoIndex].contain = '^'
      range = jumpInfo.split('=')
    }
    showAttrList[index].exprList[infoIndex].type = question.type
    jumpList[index].list[infoIndex] = question.optionList
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    let arr = range[1].substring(range[1].indexOf('[') + 1, range[1].indexOf(']')).split(',')
    //获取制定的数组
    let answerOption = []
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].indexOf('-') !== -1) {
        let itemComma = arr[i].split('-')
        arr[i] = itemComma
      }
      // 分类必选项
      if (typeof (arr[i]) === 'string') { //必须
        answerOption.push(parseInt(arr[i]))
      } else { //可选
        //循环出可选答案 列如1-4，那么生成1,2,3,4
        for (let d = Number(arr[i][0]); d < Number(arr[i][1]) + 1; d++) {
          answerOption.push(d)
        }
      }
    }
    showAttrList[index].exprList[infoIndex].optionList = answerOption
  } else if (dmLenPattern.test(jumpInfo)) {
    let range = []
    if (jumpInfo.split('!=').length > 1) {
      range = jumpInfo.split('!=')
      showAttrList[index].exprList[infoIndex].condition = '!='
    } else if (jumpInfo.split('>=').length > 1) {
      range = jumpInfo.split('>=')
      showAttrList[index].exprList[infoIndex].condition = '>='
    } else if (jumpInfo.split('<=').length > 1) {
      range = jumpInfo.split('<=')
      showAttrList[index].exprList[infoIndex].condition = '<='
    } else if (jumpInfo.split('=').length > 1) {
      range = jumpInfo.split('=')
      showAttrList[index].exprList[infoIndex].condition = '='
    } else if (jumpInfo.split('<').length > 1) {
      range = jumpInfo.split('<')
      showAttrList[index].exprList[infoIndex].condition = '<'
    } else if (jumpInfo.split('>').length > 1) {
      range = jumpInfo.split('>')
      showAttrList[index].exprList[infoIndex].condition = '>'
    }
    let arr = range[1].substring(range[1].indexOf('[') + 2, range[1].indexOf(']'))
    let val = parseInt(arr.replaceAll('#', ''))
    showAttrList[index].exprList[infoIndex].contain = '##'
    showAttrList[index].exprList[infoIndex].textOption = val
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    jumpList[index].list[infoIndex] = question.optionList
  }
}

/**
 * 条件为矩阵单选
 * @param jump
 * @param showAttrList
 * @param index
 * @param infoIndex
 * @param jumpList
 * @param question
 */
function logicJzx(jump, showAttrList, index, infoIndex, jumpList, question) {
  let jumpInfo = jump
  if (jzxPattern.test(jumpInfo)) {
    //含头不含尾
    let arr = jumpInfo.substring((jumpInfo.indexOf('[') + 1), jumpInfo.indexOf(']'))
    let range = []
    if (arr.indexOf('!=') > -1) {
      range = arr.split('!=')
      showAttrList[index].exprList[infoIndex].condition = '!='
    } else if (arr.indexOf('=') > -1) {
      range = arr.split('=')
      showAttrList[index].exprList[infoIndex].condition = '='
    }
    jumpList[index].list[infoIndex] = question.optionList
    jumpList[index].mList[infoIndex] = question.matrixList
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    showAttrList[index].exprList[infoIndex].type = 'G_JZX'
    showAttrList[index].exprList[infoIndex].matrix = parseInt(range[0])
    showAttrList[index].exprList[infoIndex].option = parseInt(range[1])
  } else if (jzxPattern2.test(jumpInfo)) {
    //含头不含尾
    let arr = jumpInfo.substring((jumpInfo.indexOf('[') + 1), jumpInfo.indexOf(']'))
    let range = []
    if (arr.indexOf('!=') > -1) {
      range = arr.split('!=')
      showAttrList[index].exprList[infoIndex].condition = '!='
    } else if (arr.indexOf('=') > -1) {
      range = arr.split('=')
      showAttrList[index].exprList[infoIndex].condition = '='
    }
    jumpList[index].list[infoIndex] = question.optionList
    jumpList[index].mList[infoIndex] = question.matrixList
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    showAttrList[index].exprList[infoIndex].type = 'G_JZX'
    showAttrList[index].exprList[infoIndex].matrix = parseInt(range[0])
    if (jumpInfo.indexOf('!=') > -1) {
      showAttrList[index].exprList[infoIndex].condition = '*!='
    } else if (jumpInfo.indexOf('=') > -1) {
      showAttrList[index].exprList[infoIndex].condition = '*='
    }
    showAttrList[index].exprList[infoIndex].type = question.type
    jumpList[index].list[infoIndex] = question.optionList
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    let optionS = arr.split(',')
    //获取制定的数组
    let answerOption = []
    for (let i = 0; i < optionS.length; i++) {
      if (optionS[i].indexOf('-') !== -1) {
        let itemComma = optionS[i].split('-')
        optionS[i] = itemComma
      }
      // 分类必选项
      if (typeof (optionS[i]) === 'string') { //必须
        answerOption.push(parseInt(optionS[i]))
      } else { //可选
        //循环出可选答案 列如1-4，那么生成1,2,3,4
        for (let d = Number(optionS[i][0]); d < Number(optionS[i][1]) + 1; d++) {
          answerOption.push(d)
        }
      }
    }
    showAttrList[index].exprList[infoIndex].optionList = answerOption
  }
}

/**
 *
 * @param jump
 * @param showAttrList
 * @param index
 * @param infoIndex
 * @param jumpList
 * @param question
 */
function logicJzM(jump, showAttrList, index, infoIndex, jumpList, question) {
  let jumpInfo = jump
  /*index 为什么会等于un*/
  showAttrList[index].exprList[infoIndex].type = 'G_JZM'
  if (jzmPattern.test(jumpInfo)) {
    //含头不含尾
    let arr = jumpInfo.substring((jumpInfo.indexOf('[') + 1), jumpInfo.indexOf(']'))
    let range = []
    let type = 'eq'
    if (arr.indexOf('!=') > -1) {
      range = arr.split('!=')
      type = 'ne'
    } else if (arr.indexOf('=') > -1) {
      range = arr.split('=')
      type = 'eq'
    }
    let allArr = []
    let newArr = range[1].trim().split(',')
    /*封装答案*/
    let rangeOne = range[0].trim().split(range[0][0])[1] /** rangeOne = 1**/
    for (let i = 0; i < newArr.length; i++) {
      let state = newArr[i].indexOf('-')
      if (state !== -1) {
        let before = newArr[i].split('-')[0]
        let after = newArr[i].split('-')[1]
        for (let j = Number(before); j < Number(after) + 1; j++) {
          allArr.push(j)
        }
      } else {
        allArr.push(parseInt(newArr[i]))
      }
    }
    if (range[0][0] === '*') {
      showAttrList[index].exprList[infoIndex].option = allArr[0]
      showAttrList[index].exprList[infoIndex].contain = type === 'ne' ? '!*' : '*'
    } else if (range[0][0] === '^') {
      /**根据=拆分得到range = [?1,1,3-5]1,3-5数组第二个元素**/
      let answerData = range[1].split(',')
      let optionAnswers = answerData
      let answerOption = []
      /*封装答案*/
      for (let i = 0; i < answerData.length; i++) {
        if (answerData[i].indexOf('-') !== -1) {
          let itemComma = optionAnswers[i].split('-')
          answerData[i] = itemComma
        }
        // 分类必选项
        if (typeof (answerData[i]) === 'string') { //必须
          answerOption.push(parseInt(answerData[i]))
        } else { //可选
          //循环出可选答案 列如1-4，那么生成1,2,3,4
          for (let d = Number(optionAnswers[i][0]); d < Number(optionAnswers[i][1]) + 1; d++) {
            answerOption.push(d)
          }
        }
      }
      showAttrList[index].exprList[infoIndex].contain = type === 'ne' ? '!^' : '^'
      showAttrList[index].exprList[infoIndex].optionList = answerOption
    }
    jumpList[index].list[infoIndex] = question.optionList
    jumpList[index].mList[infoIndex] = question.matrixList
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    showAttrList[index].exprList[infoIndex].type = 'G_JZM'
    showAttrList[index].exprList[infoIndex].matrix = parseInt(rangeOne)
  } else if (jzmPattern2.test(jumpInfo)) {
    let firstIndex = jumpInfo.indexOf('[')
    let lastIndex = jumpInfo.indexOf(']')
    let str = jumpInfo.substring(lastIndex + 1, jumpInfo.length)
    //含头不含尾
    let arr = jumpInfo.substring(firstIndex + 1, lastIndex)
    let range = arr.split('=')
    if (str.split('!=').length > 1) {
      str = str.replace('!=', '')
      showAttrList[index].exprList[infoIndex].condition = '!='
    } else if (str.split('>=').length > 1) {
      str = str.replace('>=', '')
      showAttrList[index].exprList[infoIndex].condition = '>='
    } else if (str.split('<=').length > 1) {
      str = str.replace('<=', '')
      showAttrList[index].exprList[infoIndex].condition = '<='
    } else if (str.split('=').length > 1) {
      str = str.replace('=', '')
      showAttrList[index].exprList[infoIndex].condition = '='
    } else if (str.split('<').length > 1) {
      str = str.replace('<', '')
      showAttrList[index].exprList[infoIndex].condition = '<'
    } else if (str.split('>').length > 1) {
      str = str.replace('>', '')
      showAttrList[index].exprList[infoIndex].condition = '>'
    }
    /**根据=拆分得到range = [?1,1,3-5]1,3-5数组第二个元素**/
    let answerData = range[1].split(',')
    let optionAnswers = answerData
    let answerOption = []
    let val = range[0].trim().replaceAll('$', '')
    /*封装答案*/
    for (let i = 0; i < answerData.length; i++) {
      if (answerData[i].indexOf('-') !== -1) {
        let itemComma = optionAnswers[i].split('-')
        answerData[i] = itemComma
      }
      // 分类必选项
      if (typeof (answerData[i]) === 'string') { //必须
        answerOption.push(parseInt(answerData[i]))
      } else { //可选
        //循环出可选答案 列如1-4，那么生成1,2,3,4
        for (let d = Number(optionAnswers[i][0]); d < Number(optionAnswers[i][1]) + 1; d++) {
          answerOption.push(d)
        }
      }
    }

    jumpList[index].list[infoIndex] = question.optionList
    jumpList[index].mList[infoIndex] = question.matrixList
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    showAttrList[index].exprList[infoIndex].type = 'G_JZM'
    showAttrList[index].exprList[infoIndex].contain = '$'
    showAttrList[index].exprList[infoIndex].optionList = answerOption
    showAttrList[index].exprList[infoIndex].textOption = parseInt(str)
    showAttrList[index].exprList[infoIndex].matrix = parseInt(val)
  } else if (jzmLenPattern.test(jumpInfo)) {
    //含头不含尾
    let arr = jumpInfo.substring((jumpInfo.indexOf('[') + 1), jumpInfo.indexOf(']'))
    let range = []
    if (arr.split('!=').length > 1) {
      range = arr.split('!=')
      showAttrList[index].exprList[infoIndex].condition = '!='
    } else if (arr.split('>=').length > 1) {
      range = arr.split('>=')
      showAttrList[index].exprList[infoIndex].condition = '>='
    } else if (arr.split('<=').length > 1) {
      range = arr.split('<=')
      showAttrList[index].exprList[infoIndex].condition = '<='
    } else if (arr.split('=').length > 1) {
      range = arr.split('=')
      showAttrList[index].exprList[infoIndex].condition = '='
    } else if (arr.split('<').length > 1) {
      range = arr.split('<')
      showAttrList[index].exprList[infoIndex].condition = '<'
    } else if (arr.split('>').length > 1) {
      range = arr.split('>')
      showAttrList[index].exprList[0].condition = '>'
    }
    let val = range[0].trim().replaceAll('#', '')
    jumpList[index].list[infoIndex] = question.optionList
    jumpList[index].mList[infoIndex] = question.matrixList
    showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
    showAttrList[index].exprList[infoIndex].type = 'G_JZM'
    showAttrList[index].exprList[infoIndex].contain = '##'
    showAttrList[index].exprList[infoIndex].textOption = parseInt(range[1])
    showAttrList[index].exprList[infoIndex].matrix = parseInt(val)
  }
}

function logicWb(jump, showAttrList, index, infoIndex, question) {
  let jumpInfo = jump
  showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
  showAttrList[index].exprList[infoIndex].type = 'G_WB'
  if (wbPattern.test(jumpInfo)) {
    let range = []
    let type = 'ne'
    if (jumpInfo.indexOf('!=') > -1) {
      range = jumpInfo.split('!=')
      type = 'ne'
    } else if (jumpInfo.indexOf('=') > -1) {
      range = jumpInfo.split('=')
      type = 'eq'
    }
    //获取替换
    range[1] = range[1].trim()
    let ontData = range[1].substring(0, 1)
    //获取最后一个百分号
    let lastData = range[1].substring(range[1].length - 1, range[1].length)
    /*那就开头是*/
    if (ontData === '%' && lastData === '%') {
      showAttrList[index].exprList[infoIndex].condition = type === 'eq' ? '3' : '4'
      //如果不 等于0
    } else if (ontData === '%' && lastData !== '%') {
      showAttrList[index].exprList[infoIndex].condition = type === 'eq' ? '1' : '11'
      //包含
    } else if (ontData !== '%' && lastData === '%') {
      showAttrList[index].exprList[infoIndex].condition = type === 'eq' ? '2' : '22'
    }
    showAttrList[index].exprList[infoIndex].textValue = range[1].replaceAll(/%/g, '')
  } else if (wbPattern2.test(jumpInfo)) {
    let range = []
    if (jumpInfo.split('!=').length > 1) {
      range = jumpInfo.split('!=')
      showAttrList[index].exprList[infoIndex].condition = '6'
    } else if (jumpInfo.split('>=').length > 1) {
      range = jumpInfo.split('>=')
      showAttrList[index].exprList[infoIndex].condition = '7'
    } else if (jumpInfo.split('<=').length > 1) {
      range = jumpInfo.split('<=')
      showAttrList[index].exprList[infoIndex].condition = '8'
    } else if (jumpInfo.split('=').length > 1) {
      range = jumpInfo.split('=')
      showAttrList[index].exprList[infoIndex].condition = '5'
    } else if (jumpInfo.split('<').length > 1) {
      range = jumpInfo.split('<')
      showAttrList[index].exprList[infoIndex].condition = '9'
    } else if (jumpInfo.split('>').length > 1) {
      range = jumpInfo.split('>')
      showAttrList[index].exprList[infoIndex].condition = '10'
    }
    showAttrList[index].exprList[infoIndex].textValue = range[1]
  }
}

function logicWm(jump, showAttrList, index, infoIndex, question, jumpList) {
  let jumpInfo = jump
  showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
  showAttrList[index].exprList[infoIndex].type = 'G_WM'
  if (wmPattern.test(jumpInfo)) {
    let arr = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    let range = []
    let type = []
    if (arr.indexOf('!=') > -1) {
      range = arr.split('!=')
      type = 'ne'
    } else if (arr.indexOf('=') > -1) {
      range = arr.split('=')
      type = 'eq'
    }
    //获取替换
    range[1] = range[1].trim()
    //第一个是不是%
    let ontData = range[1].substring(0, 1)
    //获取最后是不是%
    let lastData = range[1].substring(range[1].length - 1, range[1].length)
    /*那就开头是*/
    if (ontData === '%' && lastData === '%') {
      showAttrList[index].exprList[infoIndex].condition = type === 'eq' ? '3' : '4'
      //如果不 等于0
    } else if (ontData === '%' && lastData !== '%') {
      showAttrList[index].exprList[infoIndex].condition = type === 'eq' ? '1' : '11'
      //包含
    } else if (ontData !== '%' && lastData === '%') {
      showAttrList[index].exprList[infoIndex].condition = type === 'eq' ? '2' : '22'
    }
    showAttrList[index].exprList[infoIndex].textValue = range[1].replaceAll(/%/g, '')
    showAttrList[index].exprList[infoIndex].option = parseInt(range[0])
    jumpList[index].list[infoIndex] = question.optionList
  } else if (wmPattern2.test(jumpInfo)) {
    let arr = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    let range = []
    if (arr.split('!=').length > 1) {
      range = arr.split('!=')
      showAttrList[index].exprList[infoIndex].condition = '6'
    } else if (arr.split('>=').length > 1) {
      range = arr.split('>=')
      showAttrList[index].exprList[infoIndex].condition = '7'
    } else if (arr.split('<=').length > 1) {
      range = arr.split('<=')
      showAttrList[index].exprList[infoIndex].condition = '8'
    } else if (arr.split('=').length > 1) {
      range = arr.split('=')
      showAttrList[index].exprList[infoIndex].condition = '5'
    } else if (arr.split('<').length > 1) {
      range = arr.split('<')
      showAttrList[index].exprList[infoIndex].condition = '9'
    } else if (arr.split('>').length > 1) {
      range = arr.split('>')
      showAttrList[index].exprList[infoIndex].condition = '10'
    }
    showAttrList[index].exprList[infoIndex].textValue = range[1]
    showAttrList[index].exprList[infoIndex].option = parseInt(range[0])
    jumpList[index].list[infoIndex] = question.optionList
  }
}

function logicPx(jump, showAttrList, index, infoIndex, question, jumpList) {
  let jumpInfo = jump
  showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
  showAttrList[index].exprList[infoIndex].type = 'G_PX'
  if (wmPattern2.test(jumpInfo)) {
    let arr = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    let range = []
    if (arr.split('!=').length > 1) {
      range = arr.split('!=')
      showAttrList[index].exprList[infoIndex].condition = '6'
    } else if (arr.split('>=').length > 1) {
      range = arr.split('>=')
      showAttrList[index].exprList[infoIndex].condition = '7'
    } else if (arr.split('<=').length > 1) {
      range = arr.split('<=')
      showAttrList[index].exprList[infoIndex].condition = '8'
    } else if (arr.split('=').length > 1) {
      range = arr.split('=')
      showAttrList[index].exprList[infoIndex].condition = '5'
    } else if (arr.split('<').length > 1) {
      range = arr.split('<')
      showAttrList[index].exprList[infoIndex].condition = '9'
    } else if (arr.split('>').length > 1) {
      range = arr.split('>')
      showAttrList[index].exprList[infoIndex].condition = '10'
    }
    showAttrList[index].exprList[infoIndex].textValue = range[1]
    showAttrList[index].exprList[infoIndex].option = parseInt(range[0])
    jumpList[index].list[infoIndex] = question.optionList
  }
}

function logicDf(jump, showAttrList, index, infoIndex, question, jumpList) {
  let jumpInfo = jump
  showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
  showAttrList[index].exprList[infoIndex].type = 'G_DF'
  if (wmPattern2.test(jumpInfo)) {
    let arr = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    let range = []
    if (arr.split('!=').length > 1) {
      range = arr.split('!=')
      showAttrList[index].exprList[infoIndex].condition = '6'
    } else if (arr.split('>=').length > 1) {
      range = arr.split('>=')
      showAttrList[index].exprList[infoIndex].condition = '7'
    } else if (arr.split('<=').length > 1) {
      range = arr.split('<=')
      showAttrList[index].exprList[infoIndex].condition = '8'
    } else if (arr.split('=').length > 1) {
      range = arr.split('=')
      showAttrList[index].exprList[infoIndex].condition = '5'
    } else if (arr.split('<').length > 1) {
      range = arr.split('<')
      showAttrList[index].exprList[infoIndex].condition = '9'
    } else if (arr.split('>').length > 1) {
      range = arr.split('>')
      showAttrList[index].exprList[infoIndex].condition = '10'
    }
    showAttrList[index].exprList[infoIndex].textValue = range[1]
    showAttrList[index].exprList[infoIndex].option = parseInt(range[0])
    jumpList[index].list[infoIndex] = question.optionList
  }
}

//级联题逻辑
function logicJl(jump, showAttrList, index, infoIndex, question, jumpList) {
  let jumpInfo = jump
  showAttrList[index].exprList[infoIndex].startLabel = '@' + question.label
  showAttrList[index].exprList[infoIndex].type = 'G_JL'
  if (jlPattern.test(jumpInfo)) {
    if (jumpInfo.indexOf('!=') > -1) {
      showAttrList[index].exprList[infoIndex].condition = '!='
    } else if (jumpInfo.indexOf('=') > -1) {
      showAttrList[index].exprList[infoIndex].condition = '='
    }
    let context = jumpInfo.substring(jumpInfo.indexOf('[') + 1, jumpInfo.indexOf(']'))
    let contexts = context.split(',')
    showAttrList[index].exprList[infoIndex].cascadeList = contexts.reduce((a, b, index) => {
      a.push(b.split('.'))
      return a
    }, [])
    jumpList[index].cList[infoIndex] = question.cascadeList
  }
}

/**
 *
 * @param logicList
 * @param questionList
 */
export const codeEcho = (logicList, questionList, type) => {
  let result = {}
  let showAttrList = []
  let jumpList = []
  logicList.forEach((item, index) => {
      showAttrList.push({
        exprList: [
          /*单选题结构 @1=1 jump */
          {
            cascadeList: [],
            startLabel: '',
            //文本的选项绑定
            textOption: '',
            //文本的绑定的值
            textValue: '',
            //多文本的行数
            textMatrix: '',
            condition: '',
            option: null,
            //多选绑定的数组
            optionList: [],
            type: '',
            //满足的绑定
            contain: '',
            matrixList: [],
            //矩阵的行数组
            matrix: '',
            //多选的可选必选
            logicOptional: '',
            //矩阵多选满足的符合多少的条件
            satisfy: ''
          }
        ],
        result: '',
        resultLabel: '',
        logicCondition: '',
        hideList: [],
        cascadeList: [],
        hideLabel: ''
      })

      jumpList.push({list: [], mList: [], cList: []})
      let jumps = []
      item = item.toLocaleLowerCase()
      if (item.indexOf('jump') > -1) {
        jumps = item.split('jump')
        showAttrList[index].result = 'jump'
        showAttrList[index].resultLabel = jumps[1].trim()
      } else if (item.indexOf('stop') > -1) {
        jumps = item.split('stop')
        showAttrList[index].result = 'stop'
      } else if (item.indexOf('quit') > -1) {
        jumps = item.split('quit')
        showAttrList[index].result = 'quit'
      } else if (item.indexOf('m_exclude') > -1) {
        jumps = item.split('m_exclude')
        showAttrList[index].result = 'm_exclude'
      } else if (item.indexOf('i_exclude') > -1) {
        jumps = item.split('i_exclude')
        showAttrList[index].result = 'i_exclude'
      } else if (item.indexOf('c_exclude') > -1) {
        jumps = item.split('c_exclude')
        showAttrList[index].result = 'c_exclude'
      } else if (item.indexOf('exclude') > -1) {
        jumps = item.split('exclude')
        showAttrList[index].result = 'exclude'
      } else {
        if (type === 'init') {
          jumps = [item + ' ']
        } else {
          jumps = [item]
        }
      }
      let jumpOr = jumps[0].split('or')
      let jumpAnd = jumps[0].split('and')
      if (jumpOr.length > 1) { //如果是OR逻辑就走这块
        showAttrList[index].logicCondition = 'or'
        let res = {}
        res = excludeFun(' ', jumps[1], showAttrList[index].result)
        if (res.type === '1') {
          showAttrList[index].result = 'exclude'
          showAttrList[index].hideList = res.contexts
        } else if (res.type === '2') {
          showAttrList[index].result = res.contexts[1]
          showAttrList[index].hideLabel = res.contexts[0]
        } else if (res.type === '3') {
          showAttrList[index].result = 'c_exclude'
          showAttrList[index].cascadeList = res.contexts
        } else if (res.type === '4') {
          showAttrList[index].result = 'i_exclude'
          showAttrList[index].cascadeList = res.contexts
        } else if (res.type === '5') {
          showAttrList[index].result = 'm_exclude'
          showAttrList[index].hideList = res.contexts
        } else if (res.type === '6') {
          showAttrList[index].result = res.contexts[1]
          showAttrList[index].hideLabel = res.contexts[0]
        }
        for (let i = 0; i < jumpOr.length; i++) {
          if (i !== 0) {
            showAttrList[index].exprList.push({
              startLabel: '',
              //文本的选项绑定
              textOption: '',
              //文本的绑定的值
              textValue: '',
              //多文本的行数
              textMatrix: '',
              condition: '',
              option: null,
              //多选绑定的数组
              optionList: [],
              type: '',
              //满足的绑定
              contain: '',
              matrixList: [],
              //矩阵的行数组
              matrix: '',
              //多选的可选必选
              logicOptional: '',
              //矩阵多选满足的符合多少的条件
              satisfy: ''
            })
          }
          let val = undefined
          let showIndex = index
          if (dmPattern2.test(jumpOr[i])
            || jzmPattern2.test(jumpOr[i])
            || wmPattern.test(jumpOr[i])
            || wmPattern2.test(jumpOr[i])
            || jzxPattern.test(jumpOr[i])
            || jzxPattern2.test(jumpOr[0])
            || jzmPattern.test(jumpOr[i])
            || jzmLenPattern.test(jumpOr[i])
          ) {
            val = jumpOr[i].substring(0, jumpOr[i].indexOf('['))
          } else {
            if (jumpOr[i].indexOf('>=') > -1) {
              val = jumpOr[i].replace('>', '')
            } else if (jumpOr[i].indexOf('!=') > -1) {
              val = jumpOr[i].replace('!', '')
            } else if (jumpOr[i].indexOf('<=') > -1) {
              val = jumpOr[i].replace('<', '')
            } else {
              val = jumpOr[i]
            }
          }
          let question = questionList.find((q => {
            return '@' + q.label === val.split('=')[0].trim() || '@' + q.label === val.split('>')[0].trim() || '@' + q.label === val.split('<')[0].trim()
          }))
          if (question.type === 'G_DX' || question.type === 'G_TP' || question.type === 'G_ZT' || question.type === 'G_RD') {
            logicDx(jumpOr[i], showAttrList, showIndex, i, jumpList, question)
          } else if (question.type === 'G_DM' || question.type === 'G_ZM' || question.type === 'G_YB' || question.type === 'G_RM') {
            logicDm(jumpOr[i], showAttrList, showIndex, i, jumpList, question)
          } else if (question.type === 'G_JZX') {
            logicJzx(jumpOr[i], showAttrList, showIndex, i, jumpList, question)
          } else if (question.type === 'G_JZM') {
            logicJzM(jumpOr[i], showAttrList, showIndex, i, jumpList, question)
          } else if (question.type === 'G_WB') {
            logicWb(jumpOr[i], showAttrList, showIndex, i, question)
          } else if (question.type === 'G_WM') {
            logicWm(jumpOr[i], showAttrList, showIndex, i, question, jumpList)
          } else if (question.type === 'G_PX') {
            logicPx(jumpOr[i], showAttrList, showIndex, i, question, jumpList)
          } else if (question.type === 'G_DF') {
            logicDf(jumpOr[i], showAttrList, showIndex, i, question, jumpList)
          }
        }
      } else if (jumpAnd.length > 1) {
        showAttrList[index].logicCondition = 'and'
        let res = {}
        res = excludeFun(' ', jumps[1], showAttrList[index].result)
        if (res.type === '1') {
          showAttrList[index].result = 'exclude'
          showAttrList[index].hideList = res.contexts
        } else if (res.type === '2') {
          showAttrList[index].result = res.contexts[1]
          showAttrList[index].hideLabel = res.contexts[0]
        } else if (res.type === '3') {
          showAttrList[index].result = 'c_exclude'
          showAttrList[index].cascadeList = res.contexts
        } else if (res.type === '4') {
          showAttrList[index].result = 'i_exclude'
          showAttrList[index].cascadeList = res.contexts
        } else if (res.type === '5') {
          showAttrList[index].result = 'm_exclude'
          showAttrList[index].hideList = res.contexts
        } else if (res.type === '6') {
          showAttrList[index].result = res.contexts[1]
          showAttrList[index].hideLabel = res.contexts[0]
        }
        for (let i = 0; i < jumpAnd.length; i++) {
          if (i !== 0) {
            showAttrList[index].exprList.push({
              startLabel: '',
              //文本的选项绑定
              textOption: '',
              //文本的绑定的值
              textValue: '',
              //多文本的行数
              textMatrix: '',
              condition: '',
              option: null,
              //多选绑定的数组
              optionList: [],
              type: '',
              //满足的绑定
              contain: '',
              matrixList: [],
              //矩阵的行数组
              matrix: '',
              //多选的可选必选
              logicOptional: '',
              //矩阵多选满足的符合多少的条件
              satisfy: ''
            })
          }
          let val = undefined
          let showIndex = index
          if (dmPattern2.test(jumpAnd[i])
            || jzmPattern2.test(jumpAnd[i])
            || wmPattern.test(jumpAnd[i])
            || wmPattern2.test(jumpAnd[i])
            || jzxPattern.test(jumpAnd[i])
            || jzmPattern.test(jumpAnd[i])
            || jzxPattern2.test(jumpAnd[0])
            || jzmLenPattern.test(jumpAnd[i])
          ) {
            val = jumpAnd[i].substring(0, jumpAnd[i].indexOf('['))
          } else {
            if (jumpAnd[i].indexOf('>=') > -1) {
              val = jumpAnd[i].replace('>', '')
            } else if (jumpAnd[i].indexOf('!=') > -1) {
              val = jumpAnd[i].replace('!', '')
            } else if (jumpAnd[i].indexOf('<=') > -1) {
              val = jumpAnd[i].replace('<', '')
            } else {
              val = jumpAnd[i]
            }
          }
          let question = questionList.find((q => {
            return '@' + q.label === val.split('=')[0].trim() || '@' + q.label === val.split('>')[0].trim() || '@' + q.label === val.split('<')[0].trim()
          }))
          if (question.type === 'G_DX' || question.type === 'G_TP' || question.type === 'G_ZT' || question.type === 'G_RD') {
            logicDx(jumpAnd[i], showAttrList, showIndex, i, jumpList, question)
          } else if (question.type === 'G_DM' || question.type === 'G_ZM' || question.type === 'G_YB' || question.type === 'G_RM') {
            logicDm(jumpAnd[i], showAttrList, showIndex, i, jumpList, question)
          } else if (question.type === 'G_JZX') {
            logicJzx(jumpAnd[i], showAttrList, showIndex, i, jumpList, question)
          } else if (question.type === 'G_JZM') {
            logicJzM(jumpAnd[i], showAttrList, showIndex, i, jumpList, question)
          } else if (question.type === 'G_WB') {
            logicWb(jumpAnd[i], showAttrList, showIndex, i, question)
          } else if (question.type === 'G_WM') {
            logicWm(jumpAnd[i], showAttrList, showIndex, i, question, jumpList)
          } else if (question.type === 'G_ZD') {
            logicWm(jumpAnd[i], showAttrList, showIndex, i, question, jumpList)
          } else if (question.type === 'G_PX') {
            logicPx(jumpAnd[i], showAttrList, showIndex, i, question, jumpList)
          } else if (question.type === 'G_DF') {
            logicDf(jumpAnd[i], showAttrList, showIndex, i, question, jumpList)
          } else if (question.type === 'G_JL') {
            logicJl(jumpAnd[i], showAttrList, showIndex, i, question, jumpList)
          }
        }
      } else {
        let jump = jumps
        let val = undefined
        let showIndex = index
        if (dmPattern2.test(jump[0])
          || jzmPattern2.test(jump[0])
          || wmPattern.test(jump[0])
          || wmPattern2.test(jump[0])
          || jzxPattern.test(jump[0])
          || jzxPattern2.test(jump[0])
          || jzmPattern.test(jump[0])
          || jzmLenPattern.test(jump[0])
        ) {
          val = jump[0].substring(0, jump[0].indexOf('['))
        } else {
          if (jump[0].indexOf('>=') > -1) {
            val = jump[0].replace('>', '')
          } else if (jump[0].indexOf('!=') > -1) {
            val = jump[0].replace('!', '')
          } else if (jump[0].indexOf('<=') > -1) {
            val = jump[0].replace('<', '')
          } else {
            val = jump[0]
          }
        }
        let res = {}
        if (jump.length > 1) {
          res = excludeFun(' ', jump[1], showAttrList[index].result)
        }
        if (res.type === '1') {
          showAttrList[showIndex].result = 'exclude'
          showAttrList[showIndex].hideList = res.contexts
        } else if (res.type === '2') {
          showAttrList[showIndex].result = res.contexts[1]
          showAttrList[showIndex].hideLabel = res.contexts[0]
        } else if (res.type === '3') {
          showAttrList[showIndex].result = 'c_exclude'
          showAttrList[showIndex].cascadeList = res.contexts
        } else if (res.type === '4') {
          showAttrList[showIndex].result = 'i_exclude'
          showAttrList[showIndex].cascadeList = res.contexts
        } else if (res.type === '5') {
          showAttrList[showIndex].result = 'm_exclude'
          showAttrList[showIndex].hideList = res.contexts
        } else if (res.type === '6') {
          showAttrList[showIndex].result = res.contexts[1]
          showAttrList[showIndex].hideLabel = res.contexts[0]
        }
        if (jump[0].trim() !== '') {
          let question = questionList.find((q => {
            return '@' + q.label === val.split('=')[0].trim() || '@'
              + q.label === val.split('>')[0].trim() || '@' +
              q.label === val.split('<')[0].trim()
          }))
          if (question.type === 'G_DX' || question.type === 'G_TP' || question.type === 'G_ZT' || question.type === 'G_RD') {
            logicDx(jump[0], showAttrList, showIndex, 0, jumpList, question)
          } else if (question.type === 'G_DM' || question.type === 'G_ZM' || question.type === 'G_YB' || question.type === 'G_RM') {
            logicDm(jump[0], showAttrList, showIndex, 0, jumpList, question)
          } else if (question.type === 'G_JZX') {
            logicJzx(jump[0], showAttrList, showIndex, 0, jumpList, question)
          } else if (question.type === 'G_JZM') {
            logicJzM(jump[0], showAttrList, showIndex, 0, jumpList, question)
          } else if (question.type === 'G_WB') {
            logicWb(jump[0], showAttrList, showIndex, 0, question)
          } else if (question.type === 'G_WM') {
            logicWm(jump[0], showAttrList, showIndex, 0, question, jumpList)
          } else if (question.type === 'G_ZD') {
            logicWm(jump[0], showAttrList, showIndex, 0, question, jumpList)
          } else if (question.type === 'G_PX') {
            logicPx(jump[0], showAttrList, showIndex, 0, question, jumpList)
          } else if (question.type === 'G_DF') {
            logicDf(jump[0], showAttrList, showIndex, 0, question, jumpList)
          } else if (question.type === 'G_JL') {
            logicJl(jump[0], showAttrList, showIndex, 0, question, jumpList)
          }
        }
      }
    }
  )
  result.showAttrList = showAttrList
  result.jumpList = jumpList
  return result
}

/**
 * 判空
 * @param v
 * @returns {boolean}
 */
export const empty = function (v) {
  switch (typeof v) {
    case 'undefined' :
      return true
    case 'string' :
      if (v.trim().length == 0) return true
      break
    case 'boolean' :
      if (!v) return true
      break
    case 'number' :
      if (0 === v) return true
      break
    case 'object' :
      if (null === v) return true
      if (undefined !== v.length && v.length == 0) return true
      for (let k in v) {
        return false
      }
      return true
      break
  }
  return false
}

export const computeChartLegend = function (legendLength, legendItemHeight) {
  return (Math.ceil(Number(legendLength)) / 2) * legendItemHeight <= legendItemHeight ?
    '10%' : (Math.ceil(Number(legendLength)) / 2) * legendItemHeight
}
export const getQuestionType = function (type,item) {
  let types = [
    {
      title: '单选题',
      type: 'G_DX',
    },
    {
      title: '多选题',
      type: 'G_DM',
    },
    {
      title: '组题',
      type: 'G_ZT',
    },
    {
      title: '组题多选',
      type: 'G_ZM',
    },
    {
      title: '图片热点',
      type: 'G_RD',
    },
    {
      title: '文本题',
      type: 'G_WB',
    },
    {
      title: '多行文本',
      type: 'G_WM',
    },
    {
      title: '多字段',
      type: 'G_ZD',
    },
    {
      title: '矩阵单选',
      type: 'G_JZX',
    },
    {
      title: '矩阵多选',
      type: 'G_JZM',
    },
    {
      title: '排序题',
      type: 'G_PX',
    },
    {
      title: '下拉题',
      type: 'G_XL',
    },
    {
      title: '打分题',
      type: 'G_DF',
    },
    {
      title: '哑题',
      type: 'G_YB',
    },
    {
      title: '级联题',
      type: 'G_JL',
    },
    {
      title: '信息题',
      type: 'G_XX',
      defaultDesc: '信息题请修改'
    },
    {
      title: '单选题',
      type: 'G_TP',
      defaultDesc: '标题请修改'
    },
    {
      title: '矩阵下拉',
      type: 'G_JZL',
      defaultDesc: '矩阵下拉'
    },
    {
      title: '文件题',
      type: 'G_WJ',
      defaultDesc: '问题%s文件题请修改标题'
    },
    {
      title:"Maxdiff题",
      type:"G_MF",
      icon: "MF",
      defaultDesc:"问题%sMaxdiff题请修改标题"
    },{
      title: '矩阵填空',
      type: 'G_JZW',
      defaultDesc: '问题%s矩阵填空请修改标题'
    },
    {
      title: '过渡页面',
      type: 'G_GD',
      defaultDesc: ''
    },
    {
      title: '链接分裂',
      type: 'G_YB',
      isLink:true,
      defaultDesc: '链接分裂题请勿修改'
    },
  ]
  let data = types.find(entry => {
    // 1. type 不匹配，直接排除
    if (entry.type !== type) return false;
    // 2. type 匹配上了，如果是 G_YB，再用 isLink 区分"哑题"和"链接分裂"
    if (type === 'G_YB') {
      if (entry.isLink) {
        return !!(item && item.isLink === true);  // 链接分裂
      }
      return !item || !item.isLink;               // 哑题
    }
    return true;
  });
  if (data) {
    return data.title
  } else {
    return '未知'
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js